import { render, staticRenderFns } from "./сreate-connection-card.vue?vue&type=template&id=3fad1710&scoped=true"
import script from "./сreate-connection-card.vue?vue&type=script&lang=ts"
export * from "./сreate-connection-card.vue?vue&type=script&lang=ts"
import style0 from "./сreate-connection-card.vue?vue&type=style&index=0&id=3fad1710&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fad1710",
  null
  
)

export default component.exports